import { Award, Handshake, LineChart, Users2, ShieldCheck, Sparkles } from "lucide-react";

const pillars = [
  {
    icon: Award,
    title: "Minority-Owned Excellence",
    body: "Founded and led with the ambition to become a leading minority-owned consulting and business services firm.",
  },
  {
    icon: Handshake,
    title: "Consulting + Execution",
    body: "We don’t just advise — we operate. Bookkeeping and property management divisions give plans real hands.",
  },
  {
    icon: LineChart,
    title: "Sustainable Growth Lens",
    body: "Every recommendation is stress-tested for long-term impact, not short-term optics.",
  },
  {
    icon: Users2,
    title: "Workforce Development Focus",
    body: "Training and guidance are built to lift teams, not just leaders — because talent is the strategy.",
  },
  {
    icon: ShieldCheck,
    title: "Trusted with Your Numbers",
    body: "QuickBooks pros keep your books clean, reconciled, and month-close ready.",
  },
  {
    icon: Sparkles,
    title: "Purpose-Driven Portfolio",
    body: "Short-term and Long-term rental portfolios that contribute to local economic development and employment.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32">
      <div className="kat-container">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="overline">Why KAT Consulting & Branding</p>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[color:var(--kat-navy)]">
              Consulting firms give you a slide deck. We give you a system.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg text-[color:var(--kat-muted)] leading-relaxed">
            Six reasons partners choose KAT Consulting & Branding — and stay.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pillars.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`why-pillar-${idx + 1}`}
                className="group relative border border-slate-200 bg-white p-8 rounded-sm transition-all duration-500 hover:-translate-y-1 hover:shadow-lg hover:border-[color:var(--kat-navy)]"
              >
                <div className="w-12 h-12 rounded-sm border border-slate-300 flex items-center justify-center text-[color:var(--kat-navy)] group-hover:bg-[color:var(--kat-navy)] group-hover:text-white transition-colors">
                  <Icon size={18} strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-[color:var(--kat-navy)] leading-snug">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-[color:var(--kat-muted)]">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
